import { WlWindow } from 'typings/globals/cordova';

declare const window: WlWindow & { Cypress?: any };

export function isCordova() {
  return PLATFORM === 'cordova';
}

export function isWeb() {
  return !isCordova();
}

export function fullUserAgent() {
  return (
    window?.navigator?.userAgent +
    ((window.navigator?.userAgent?.indexOf(' wlApp') === -1 && USERAGENT) || '')
  );
}

export function isAndroidApp() {
  return CORDOVA_PLATFORM === 'android';
}

export function isIosApp() {
  return CORDOVA_PLATFORM === 'ios';
}

export function isAndroidWeb() {
  return /android/i.test(navigator?.userAgent || navigator?.vendor);
}

export function isIosWeb() {
  return /iPad|iPhone|iPod/.test(navigator?.userAgent) && !window.MSStream;
}

export function isCypress(): boolean {
  try {
    return typeof window !== 'undefined' && !!(window as any).Cypress;
  } catch (e) {
    return false;
  }
}
